import React, { useEffect, useState } from 'react';
import {
  adminGetSoundEngineeringList, adminAddSoundEngineeringEmail, adminRemoveSoundEngineeringEmail,
  adminUpdateSoundEngineeringEmail,
  adminGetVenues, adminCreateVenue, adminDeleteVenue,
  adminGetBookingManagers, adminAddBookingManager, adminRemoveBookingManager,
  adminUpdateBookingManager, adminInviteBookingManager,
  adminGetMcs, adminCreateMc, adminUpdateMc, adminDeleteMc,
  adminGetAdminList,
} from '../services/api';
import Navbar from '../components/Navbar';
import AdminTabBar from '../components/AdminTabBar';

const formatDate = (d) => d
  ? new Date(d).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' })
  : '—';

function RemoveButton({ onClick, loading }) {
  return (
    <button
      className="a-btn a-btn--ghost a-btn--sm"
      onClick={onClick}
      disabled={loading}
      style={{ color: 'var(--red)', borderColor: 'var(--red)' }}
    >
      {loading ? '…' : 'Remove'}
    </button>
  );
}

const MC_EMPTY_FORM = { name: '', email: '', phone: '', notes: '' };

export default function AdminDistributionListPage() {
  // ── Sound Engineering Recipients ──
  const [soundies,        setSoundies]        = useState([]);
  const [soundiesLoading, setSoundiesLoading] = useState(true);
  const [soundieError,    setSoundieError]    = useState('');
  const [soundieMsg,      setSoundieMsg]      = useState('');
  const [showSoundieModal, setShowSoundieModal] = useState(false);
  const [newSoundieEmail,  setNewSoundieEmail]  = useState('');
  const [newSoundieName,   setNewSoundieName]   = useState('');
  const [addingSoundie,    setAddingSoundie]    = useState(false);
  const [removingSoundie,  setRemovingSoundie]  = useState(null);

  // ── Venues ──
  const [venues,        setVenues]        = useState([]);
  const [venuesLoading, setVenuesLoading] = useState(true);
  const [venueError,    setVenueError]    = useState('');
  const [venueMsg,      setVenueMsg]      = useState('');
  const [showVenueModal, setShowVenueModal] = useState(false);
  const [newVenueName,   setNewVenueName]   = useState('');
  const [newVenueAddr,   setNewVenueAddr]   = useState('');
  const [addingVenue,    setAddingVenue]    = useState(false);
  const [removingVenue,  setRemovingVenue]  = useState(null);
  const [showDeleteVenue, setShowDeleteVenue] = useState(null);

  // ── Booking Managers ──
  const [bookingManagers, setBookingManagers] = useState([]);
  const [bmLoading,       setBmLoading]       = useState(true);
  const [bmError,         setBmError]         = useState('');
  const [bmMsg,           setBmMsg]           = useState('');
  const [newBmEmail,      setNewBmEmail]      = useState('');
  const [newBmName,       setNewBmName]       = useState('');
  const [addingBm,        setAddingBm]        = useState(false);
  const [removingBm,      setRemovingBm]      = useState(null);
  const [showBmModal,     setShowBmModal]     = useState(false);
  const [showEditBmModal, setShowEditBmModal] = useState(false);
  const [editBmRow,       setEditBmRow]       = useState(null);
  const [editBmForm,      setEditBmForm]      = useState({ name: '', email: '' });
  const [savingBmEdit,    setSavingBmEdit]    = useState(false);
  const [bmEditError,     setBmEditError]     = useState('');
  const [invitingBm,      setInvitingBm]      = useState(null);

  // ── Soundie edit ──
  const [showEditSoundieModal, setShowEditSoundieModal] = useState(false);
  const [editSoundieRow,       setEditSoundieRow]       = useState(null);
  const [editSoundieEmail,     setEditSoundieEmail]     = useState('');
  const [savingSoundieEdit,    setSavingSoundieEdit]    = useState(false);
  const [soundieEditError,     setSoundieEditError]     = useState('');

  // ── Admins (read-only) ──
  // Moved here from the Admin Emails tab, which held nothing else. The accounts
  // themselves are managed in the Sophtplanet Dashboard, so this is a list to
  // read, not to edit — same as it was before the move.
  const [admins,        setAdmins]        = useState([]);
  const [adminsLoading, setAdminsLoading] = useState(true);
  const [adminsError,   setAdminsError]   = useState('');

  // ── MCs ──
  const [mcs,           setMcs]           = useState([]);
  const [mcsLoading,    setMcsLoading]    = useState(true);
  const [mcError,       setMcError]       = useState('');
  const [showMcModal,   setShowMcModal]   = useState(false);
  const [editMc,        setEditMc]        = useState(null);
  const [mcForm,        setMcForm]        = useState(MC_EMPTY_FORM);
  const [mcSaving,      setMcSaving]      = useState(false);
  const [mcFormError,   setMcFormError]   = useState('');
  const [deleteMcConfirm, setDeleteMcConfirm] = useState(null);
  const [deletingMc,    setDeletingMc]    = useState(false);

  const currentUser = (() => {
    try { return JSON.parse(localStorage.getItem('user') || '{}'); }
    catch { return {}; }
  })();
  const isAdmin = ['admin', 'metaadmin'].includes(currentUser.role);

  useEffect(() => {
    adminGetSoundEngineeringList()
      .then(r => setSoundies(Array.isArray(r.data) ? r.data : []))
      .catch(() => setSoundieError('Failed to load sound engineering recipients.'))
      .finally(() => setSoundiesLoading(false));

    adminGetVenues()
      .then(r => setVenues(Array.isArray(r.data) ? r.data : []))
      .catch(() => setVenueError('Failed to load venues.'))
      .finally(() => setVenuesLoading(false));

    adminGetMcs()
      .then(r => setMcs(Array.isArray(r.data) ? r.data : []))
      .catch(() => setMcError('Failed to load MCs.'))
      .finally(() => setMcsLoading(false));

    if (isAdmin) {
      adminGetBookingManagers()
        .then(r => setBookingManagers(Array.isArray(r.data) ? r.data : []))
        .catch(() => setBmError('Failed to load booking managers.'))
        .finally(() => setBmLoading(false));

      // /admin-list is adminOnly on the server, so a booking manager must not
      // request it — a 403 here would surface as a failed-to-load error on a
      // card they cannot see anyway.
      adminGetAdminList()
        .then(r => setAdmins(Array.isArray(r.data) ? r.data : []))
        .catch(() => setAdminsError('Failed to load admin users.'))
        .finally(() => setAdminsLoading(false));
    } else {
      setBmLoading(false);
      setAdminsLoading(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Sound Engineering handlers ──
  const handleAddSoundie = async (e) => {
    e.preventDefault();
    setSoundieMsg(''); setSoundieError('');
    if (!newSoundieEmail.trim()) return;
    setAddingSoundie(true);
    try {
      const res = await adminAddSoundEngineeringEmail({ email: newSoundieEmail.trim(), name: newSoundieName.trim() || null });
      setSoundies(prev => [...prev, res.data]);
      setSoundieMsg('Added.');
      setNewSoundieEmail('');
      setNewSoundieName('');
      setShowSoundieModal(false);
    } catch (err) {
      setSoundieError(err?.response?.data?.error || 'Failed to add email.');
    } finally {
      setAddingSoundie(false);
    }
  };

  const handleRemoveSoundie = async (id) => {
    setRemovingSoundie(id); setSoundieMsg(''); setSoundieError('');
    try {
      await adminRemoveSoundEngineeringEmail(id);
      setSoundies(prev => prev.filter(r => r.id !== id));
      setSoundieMsg('Removed.');
    } catch {
      setSoundieError('Failed to remove.');
    } finally {
      setRemovingSoundie(null);
    }
  };

  // ── Venue handlers ──
  const handleAddVenue = async (e) => {
    e.preventDefault();
    setVenueMsg(''); setVenueError('');
    if (!newVenueName.trim()) return;
    setAddingVenue(true);
    try {
      const res = await adminCreateVenue({ name: newVenueName.trim(), address: newVenueAddr.trim() || null });
      setVenues(prev => [...prev, res.data].sort((a, b) => a.name.localeCompare(b.name)));
      setVenueMsg('Venue added.');
      setNewVenueName('');
      setNewVenueAddr('');
      setShowVenueModal(false);
    } catch (err) {
      setVenueError(err?.response?.data?.error || 'Failed to add venue.');
    } finally {
      setAddingVenue(false);
    }
  };

  const handleDeleteVenue = async (venue) => {
    setRemovingVenue(venue.id); setVenueMsg(''); setVenueError('');
    try {
      await adminDeleteVenue(venue.id);
      setVenues(prev => prev.filter(v => v.id !== venue.id));
      setVenueMsg('Venue removed.');
      setShowDeleteVenue(null);
    } catch {
      setVenueError('Failed to remove venue.');
    } finally {
      setRemovingVenue(null);
    }
  };

  // ── Booking Managers handlers ──
  const handleAddBm = async (e) => {
    e.preventDefault();
    setBmMsg(''); setBmError('');
    if (!newBmEmail.trim()) return;
    setAddingBm(true);
    try {
      const res = await adminAddBookingManager({ email: newBmEmail.trim(), name: newBmName.trim() || null });
      setBookingManagers(prev => [res.data, ...prev]);
      setBmMsg('Added.');
      setNewBmEmail('');
      setNewBmName('');
      setShowBmModal(false);
    } catch (err) {
      setBmError(err?.response?.data?.error || 'Failed to add booking manager.');
    } finally {
      setAddingBm(false);
    }
  };

  const handleRemoveBm = async (id) => {
    setRemovingBm(id); setBmMsg(''); setBmError('');
    try {
      await adminRemoveBookingManager(id);
      setBookingManagers(prev => prev.filter(r => r.id !== id));
      setBmMsg('Removed.');
    } catch {
      setBmError('Failed to remove.');
    } finally {
      setRemovingBm(null);
    }
  };

  const openEditBm = (row) => {
    setEditBmRow(row);
    setEditBmForm({ name: row.name || '', email: row.email });
    setBmEditError('');
    setShowEditBmModal(true);
  };

  const handleSaveBmEdit = async (e) => {
    e.preventDefault();
    setBmEditError('');
    if (!editBmForm.email.trim()) { setBmEditError('Email is required.'); return; }
    setSavingBmEdit(true);
    try {
      const res = await adminUpdateBookingManager(editBmRow.id, { name: editBmForm.name.trim() || null, email: editBmForm.email.trim() });
      setBookingManagers(prev => prev.map(r => r.id === editBmRow.id ? res.data : r));
      setShowEditBmModal(false);
    } catch (err) {
      setBmEditError(err?.response?.data?.error || 'Failed to save.');
    } finally {
      setSavingBmEdit(false);
    }
  };

  const handleInviteBm = async (id) => {
    setInvitingBm(id); setBmMsg(''); setBmError('');
    try {
      await adminInviteBookingManager(id);
      setBmMsg('Invite sent.');
    } catch (err) {
      setBmError(err?.response?.data?.error || 'Failed to send invite.');
    } finally {
      setInvitingBm(null);
    }
  };

  // ── Soundie edit handlers ──
  const openEditSoundie = (row) => {
    setEditSoundieRow(row);
    setEditSoundieEmail(row.email);
    setSoundieEditError('');
    setShowEditSoundieModal(true);
  };

  const handleSaveSoundieEdit = async (e) => {
    e.preventDefault();
    setSoundieEditError('');
    if (!editSoundieEmail.trim()) { setSoundieEditError('Email is required.'); return; }
    setSavingSoundieEdit(true);
    try {
      const res = await adminUpdateSoundEngineeringEmail(editSoundieRow.id, { email: editSoundieEmail.trim() });
      setSoundies(prev => prev.map(r => r.id === editSoundieRow.id ? res.data : r));
      setShowEditSoundieModal(false);
    } catch (err) {
      setSoundieEditError(err?.response?.data?.error || 'Failed to save.');
    } finally {
      setSavingSoundieEdit(false);
    }
  };

  // ── MC handlers ──
  const openAddMc = () => {
    setEditMc(null);
    setMcForm(MC_EMPTY_FORM);
    setMcFormError('');
    setShowMcModal(true);
  };

  const openEditMc = (mc) => {
    setEditMc(mc);
    setMcForm({ name: mc.name, email: mc.email || '', phone: mc.phone || '', notes: mc.notes || '' });
    setMcFormError('');
    setShowMcModal(true);
  };

  const handleSaveMc = async (e) => {
    e.preventDefault();
    setMcFormError('');
    if (!mcForm.name.trim()) { setMcFormError('Name is required.'); return; }
    setMcSaving(true);
    try {
      if (editMc) {
        const res = await adminUpdateMc(editMc.id, mcForm);
        setMcs(prev => prev.map(m => m.id === editMc.id ? res.data : m));
      } else {
        const res = await adminCreateMc(mcForm);
        setMcs(prev => [...prev, res.data].sort((a, b) => a.name.localeCompare(b.name)));
      }
      setShowMcModal(false);
    } catch (err) {
      setMcFormError(err?.response?.data?.error || 'Failed to save.');
    } finally {
      setMcSaving(false);
    }
  };

  const handleDeleteMc = async () => {
    if (!deleteMcConfirm) return;
    setDeletingMc(true);
    try {
      await adminDeleteMc(deleteMcConfirm.id);
      setMcs(prev => prev.filter(m => m.id !== deleteMcConfirm.id));
      setDeleteMcConfirm(null);
    } catch (err) {
      alert(err?.response?.data?.error || 'Failed to delete.');
      setDeleteMcConfirm(null);
    } finally {
      setDeletingMc(false);
    }
  };

  return (
    <>
      <Navbar />
      <AdminTabBar />
      <div style={{ maxWidth: '780px', margin: '0 auto', padding: '2rem 1rem' }}>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: 'var(--navy)', marginBottom: '2rem' }}>
          Distribution & Venues
        </h1>

        {/* ── SECTION 0: Booking Managers (admin only) ─────────────────────── */}
        {isAdmin && (
          <div style={{ marginBottom: '2.5rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.5rem' }}>
              <div>
                <h2 style={{ fontSize: '1.1rem', fontWeight: 600, color: 'var(--navy)', margin: 0 }}>Booking Managers</h2>
                <p style={{ fontSize: '0.875rem', color: 'var(--muted)', margin: '0.3rem 0 0' }}>
                  Booking managers can log in with read access to performers and full access to events.
                  Add their email here, then use Invite to send them a set-up link. They also receive every event confirmation email.
                </p>
              </div>
              <button
                className="a-btn a-btn--navy a-btn--sm"
                style={{ flexShrink: 0, marginLeft: '1rem' }}
                onClick={() => { setShowBmModal(true); setBmError(''); setBmMsg(''); }}
              >
                Add Booking Manager
              </button>
            </div>

            {bmError && <div className="a-error" style={{ marginBottom: '0.75rem' }}>{bmError}</div>}
            {bmMsg   && <div style={{ marginBottom: '0.75rem', fontSize: '0.875rem', color: 'var(--green)' }}>{bmMsg}</div>}

            <div className="a-card" style={{ padding: 0, overflow: 'hidden' }}>
              <table className="a-table" style={{ width: '100%' }}>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email Address</th>
                    <th>Added</th>
                    <th style={{ width: '200px' }}></th>
                  </tr>
                </thead>
                <tbody>
                  {bmLoading ? (
                    <tr><td colSpan={4} style={{ textAlign: 'center', color: 'var(--muted)' }}>Loading…</td></tr>
                  ) : bookingManagers.length === 0 ? (
                    <tr><td colSpan={4} style={{ textAlign: 'center', color: 'var(--muted)' }}>No booking managers.</td></tr>
                  ) : bookingManagers.map(row => (
                    <tr key={row.id}>
                      <td>{row.name || '—'}</td>
                      <td>{row.email}</td>
                      <td style={{ fontSize: '0.85rem', color: 'var(--muted)' }}>{formatDate(row.created_at)}</td>
                      <td>
                        <div style={{ display: 'flex', gap: '0.4rem' }}>
                          <button className="a-btn a-btn--ghost a-btn--sm" onClick={() => openEditBm(row)}>Edit</button>
                          <button
                            className="a-btn a-btn--ghost a-btn--sm"
                            onClick={() => handleInviteBm(row.id)}
                            disabled={invitingBm === row.id}
                          >
                            {invitingBm === row.id ? '…' : 'Invite'}
                          </button>
                          <RemoveButton onClick={() => handleRemoveBm(row.id)} loading={removingBm === row.id} />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* ── SECTION 0b: MCs ──────────────────────────────────────────────── */}
        <div style={{ marginBottom: '2.5rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.5rem' }}>
            <div>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 600, color: 'var(--navy)', margin: 0 }}>MCs</h2>
              <p style={{ fontSize: '0.875rem', color: 'var(--muted)', margin: '0.3rem 0 0' }}>
                Masters of Ceremony available for selection when creating events.
              </p>
            </div>
            <button
              className="a-btn a-btn--navy a-btn--sm"
              style={{ flexShrink: 0, marginLeft: '1rem' }}
              onClick={openAddMc}
            >
              Add MC
            </button>
          </div>

          {mcError && <div className="a-error" style={{ marginBottom: '0.75rem' }}>{mcError}</div>}

          <div className="a-card" style={{ padding: 0, overflow: 'hidden' }}>
            <table className="a-table" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Notes</th>
                  <th style={{ width: '130px' }}></th>
                </tr>
              </thead>
              <tbody>
                {mcsLoading ? (
                  <tr><td colSpan={5} style={{ textAlign: 'center', color: 'var(--muted)' }}>Loading…</td></tr>
                ) : mcs.length === 0 ? (
                  <tr><td colSpan={5} style={{ textAlign: 'center', color: 'var(--muted)' }}>No MCs added yet.</td></tr>
                ) : mcs.map(mc => (
                  <tr key={mc.id}>
                    <td style={{ fontWeight: 500 }}>{mc.name}</td>
                    <td style={{ color: 'var(--muted)', fontSize: '0.875rem' }}>{mc.email || '—'}</td>
                    <td style={{ color: 'var(--muted)', fontSize: '0.875rem' }}>{mc.phone || '—'}</td>
                    <td style={{ color: 'var(--muted)', fontSize: '0.875rem', maxWidth: '220px' }}>
                      {mc.notes ? (mc.notes.length > 60 ? mc.notes.slice(0, 60) + '…' : mc.notes) : '—'}
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: '0.4rem' }}>
                        <button className="a-btn a-btn--ghost a-btn--sm" onClick={() => openEditMc(mc)}>Edit</button>
                        <button
                          className="a-btn a-btn--ghost a-btn--sm"
                          style={{ color: 'var(--red)', borderColor: 'var(--red)' }}
                          onClick={() => setDeleteMcConfirm(mc)}
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* ── SECTION 2: Sound Engineering Recipients ──────────────────────── */}
        <div style={{ marginBottom: '2.5rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.5rem' }}>
            <div>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 600, color: 'var(--navy)', margin: 0 }}>Sound Engineering Recipients</h2>
              <p style={{ fontSize: '0.875rem', color: 'var(--muted)', margin: '0.3rem 0 0' }}>
                These addresses receive the stage requirements PDF when a booking is made.
              </p>
            </div>
            <button
              className="a-btn a-btn--navy a-btn--sm"
              style={{ flexShrink: 0, marginLeft: '1rem' }}
              onClick={() => { setShowSoundieModal(true); setSoundieError(''); setSoundieMsg(''); }}
            >
              Add Email
            </button>
          </div>

          {soundieError && <div className="a-error" style={{ marginBottom: '0.75rem' }}>{soundieError}</div>}
          {soundieMsg   && <div style={{ marginBottom: '0.75rem', fontSize: '0.875rem', color: 'var(--green)' }}>{soundieMsg}</div>}

          <div className="a-card" style={{ padding: 0, overflow: 'hidden' }}>
            <table className="a-table" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email Address</th>
                  <th>Added</th>
                  <th style={{ width: '130px' }}></th>
                </tr>
              </thead>
              <tbody>
                {soundiesLoading ? (
                  <tr><td colSpan={4} style={{ textAlign: 'center', color: 'var(--muted)' }}>Loading…</td></tr>
                ) : soundies.length === 0 ? (
                  <tr><td colSpan={4} style={{ textAlign: 'center', color: 'var(--muted)' }}>No sound engineering recipients.</td></tr>
                ) : soundies.map(row => (
                  <tr key={row.id}>
                    <td>{row.name || '—'}</td>
                    <td>{row.email}</td>
                    <td style={{ fontSize: '0.85rem', color: 'var(--muted)' }}>{formatDate(row.created_at)}</td>
                    <td>
                      <div style={{ display: 'flex', gap: '0.4rem' }}>
                        <button className="a-btn a-btn--ghost a-btn--sm" onClick={() => openEditSoundie(row)}>Edit</button>
                        <RemoveButton onClick={() => handleRemoveSoundie(row.id)} loading={removingSoundie === row.id} />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* ── SECTION 3: Venues ────────────────────────────────────────────── */}
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.5rem' }}>
            <div>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 600, color: 'var(--navy)', margin: 0 }}>Venues</h2>
              <p style={{ fontSize: '0.875rem', color: 'var(--muted)', margin: '0.3rem 0 0' }}>
                Venues available for selection when booking a performer.
              </p>
            </div>
            <button
              className="a-btn a-btn--navy a-btn--sm"
              style={{ flexShrink: 0, marginLeft: '1rem' }}
              onClick={() => { setShowVenueModal(true); setVenueError(''); setVenueMsg(''); }}
            >
              Add Venue
            </button>
          </div>

          {venueError && <div className="a-error" style={{ marginBottom: '0.75rem' }}>{venueError}</div>}
          {venueMsg   && <div style={{ marginBottom: '0.75rem', fontSize: '0.875rem', color: 'var(--green)' }}>{venueMsg}</div>}

          <div className="a-card" style={{ padding: 0, overflow: 'hidden' }}>
            <table className="a-table" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Address</th>
                  <th>Added</th>
                  <th style={{ width: '80px' }}></th>
                </tr>
              </thead>
              <tbody>
                {venuesLoading ? (
                  <tr><td colSpan={4} style={{ textAlign: 'center', color: 'var(--muted)' }}>Loading…</td></tr>
                ) : venues.length === 0 ? (
                  <tr><td colSpan={4} style={{ textAlign: 'center', color: 'var(--muted)' }}>No venues added yet.</td></tr>
                ) : venues.map(v => (
                  <tr key={v.id}>
                    <td style={{ fontWeight: 500 }}>{v.name}</td>
                    <td style={{ color: 'var(--muted)', fontSize: '0.875rem' }}>{v.address || '—'}</td>
                    <td style={{ fontSize: '0.85rem', color: 'var(--muted)' }}>{formatDate(v.created_at)}</td>
                    <td>
                      <RemoveButton
                        onClick={() => setShowDeleteVenue(v)}
                        loading={removingVenue === v.id}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* ── SECTION 4: Admins (read-only) ─────────────────────────────────
            Was its own "Admin Emails" tab, which contained this table and
            nothing else. Read-only by design: the accounts live in the
            Sophtplanet Dashboard, and this is here so you can see who holds
            admin access without leaving the app. */}
        {isAdmin && (
          <div>
            <div style={{ marginBottom: '0.5rem' }}>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 600, color: 'var(--navy)', margin: 0 }}>Admins</h2>
              <p style={{ fontSize: '0.875rem', color: 'var(--muted)', margin: '0.3rem 0 0' }}>
                Who has admin access to this system. Managed in the Sophtplanet Dashboard.
              </p>
            </div>

            {adminsError && <div className="a-error" style={{ marginBottom: '0.75rem' }}>{adminsError}</div>}

            <div className="a-card" style={{ padding: 0, overflow: 'hidden' }}>
              <table className="a-table" style={{ width: '100%' }}>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                  </tr>
                </thead>
                <tbody>
                  {adminsLoading ? (
                    <tr><td colSpan={2} style={{ textAlign: 'center', color: 'var(--muted)' }}>Loading…</td></tr>
                  ) : admins.length === 0 ? (
                    <tr><td colSpan={2} style={{ textAlign: 'center', color: 'var(--muted)' }}>No admin users found.</td></tr>
                  ) : admins.map(row => (
                    <tr key={row.id}>
                      <td style={{ fontWeight: 500 }}>{row.real_name || '—'}</td>
                      <td style={{ color: 'var(--muted)', fontSize: '0.875rem' }}>{row.email}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      {/* ── Add Booking Manager Modal ── */}
      {showBmModal && (
        <div className="a-modal-overlay" onClick={e => { if (e.target === e.currentTarget) setShowBmModal(false); }}>
          <div className="a-modal" style={{ maxWidth: '400px' }}>
            <h2 className="a-modal__title">Add Booking Manager</h2>
            <form onSubmit={handleAddBm}>
              <div className="a-field">
                <label className="a-label">Name</label>
                <input className="a-input" type="text" value={newBmName} onChange={e => setNewBmName(e.target.value)} placeholder="Full name" />
              </div>
              <div className="a-field" style={{ marginBottom: 0 }}>
                <label className="a-label">Email *</label>
                <input className="a-input" type="email" value={newBmEmail} onChange={e => setNewBmEmail(e.target.value)} placeholder="email@example.com" required />
              </div>
              <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
                <button type="button" className="a-btn a-btn--ghost" onClick={() => setShowBmModal(false)}>Cancel</button>
                <button type="submit" className="a-btn a-btn--navy" disabled={addingBm || !newBmEmail.trim()}>
                  {addingBm ? 'Adding…' : 'Add'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ── Add / Edit MC Modal ── */}
      {showMcModal && (
        <div className="a-modal-backdrop">
          <div className="a-modal" style={{ maxWidth: '460px', width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <h2 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 600 }}>
                {editMc ? 'Edit MC' : 'Add MC'}
              </h2>
              <button
                onClick={() => setShowMcModal(false)}
                style={{ background: 'none', border: 'none', fontSize: '1.25rem', cursor: 'pointer', color: 'var(--muted)' }}
              >×</button>
            </div>
            {mcFormError && <div className="a-error" style={{ marginBottom: '0.75rem' }}>{mcFormError}</div>}
            <form onSubmit={handleSaveMc}>
              <div className="a-field">
                <label className="a-label">Name *</label>
                <input
                  className="a-input" type="text" value={mcForm.name} required
                  onChange={e => setMcForm(f => ({ ...f, name: e.target.value }))}
                />
              </div>
              <div className="a-field">
                <label className="a-label">Email</label>
                <input
                  className="a-input" type="email" value={mcForm.email}
                  onChange={e => setMcForm(f => ({ ...f, email: e.target.value }))}
                />
              </div>
              <div className="a-field">
                <label className="a-label">Phone</label>
                <input
                  className="a-input" type="text" value={mcForm.phone}
                  onChange={e => setMcForm(f => ({ ...f, phone: e.target.value }))}
                />
              </div>
              <div className="a-field">
                <label className="a-label">Notes</label>
                <textarea
                  className="a-input" rows={3} value={mcForm.notes}
                  onChange={e => setMcForm(f => ({ ...f, notes: e.target.value }))}
                  style={{ resize: 'vertical' }}
                />
              </div>
              <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
                <button type="button" className="a-btn a-btn--ghost" onClick={() => setShowMcModal(false)}>
                  Cancel
                </button>
                <button type="submit" className="a-btn a-btn--navy" disabled={mcSaving}>
                  {mcSaving ? 'Saving…' : 'Save'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ── Delete MC Confirm Modal ── */}
      {deleteMcConfirm && (
        <div className="a-modal-backdrop">
          <div className="a-modal">
            <div className="a-modal__title">Delete MC</div>
            <p style={{ marginBottom: '1.25rem', color: 'var(--text)', fontSize: '0.9rem' }}>
              Delete <strong>{deleteMcConfirm.name}</strong>? This cannot be undone.
            </p>
            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
              <button className="a-btn a-btn--ghost" onClick={() => setDeleteMcConfirm(null)} disabled={deletingMc}>
                Cancel
              </button>
              <button className="a-btn a-btn--danger" onClick={handleDeleteMc} disabled={deletingMc}>
                {deletingMc ? 'Deleting…' : 'Delete'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Add Sound Engineering Email Modal ── */}
      {showSoundieModal && (
        <div className="a-modal-overlay" onClick={e => { if (e.target === e.currentTarget) setShowSoundieModal(false); }}>
          <div className="a-modal" style={{ maxWidth: '400px', width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <h2 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 600 }}>Add Sound Engineering Recipient</h2>
              <button onClick={() => setShowSoundieModal(false)} style={{ background: 'none', border: 'none', fontSize: '1.25rem', cursor: 'pointer', color: 'var(--muted)' }}>×</button>
            </div>
            {soundieError && <div className="a-error" style={{ marginBottom: '0.75rem' }}>{soundieError}</div>}
            <form onSubmit={handleAddSoundie}>
              <div className="a-field">
                <label className="a-label">Name</label>
                <input className="a-input" type="text" value={newSoundieName}
                  onChange={e => setNewSoundieName(e.target.value)} placeholder="Sound engineer name" />
              </div>
              <div className="a-field">
                <label className="a-label">Email Address</label>
                <input className="a-input" type="email" value={newSoundieEmail}
                  onChange={e => setNewSoundieEmail(e.target.value)} placeholder="email@example.com" required />
              </div>
              <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
                <button type="button" className="a-btn a-btn--ghost" onClick={() => setShowSoundieModal(false)}>Cancel</button>
                <button type="submit" className="a-btn a-btn--navy" disabled={addingSoundie}>
                  {addingSoundie ? 'Adding…' : 'Add'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ── Add Venue Modal ── */}
      {showVenueModal && (
        <div className="a-modal-overlay" onClick={e => { if (e.target === e.currentTarget) setShowVenueModal(false); }}>
          <div className="a-modal" style={{ maxWidth: '420px', width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <h2 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 600 }}>Add Venue</h2>
              <button onClick={() => setShowVenueModal(false)} style={{ background: 'none', border: 'none', fontSize: '1.25rem', cursor: 'pointer', color: 'var(--muted)' }}>×</button>
            </div>
            {venueError && <div className="a-error" style={{ marginBottom: '0.75rem' }}>{venueError}</div>}
            <form onSubmit={handleAddVenue}>
              <div className="a-field">
                <label className="a-label">Venue Name</label>
                <input className="a-input" type="text" value={newVenueName}
                  onChange={e => setNewVenueName(e.target.value)} placeholder="e.g. The Toff in Town" required />
              </div>
              <div className="a-field">
                <label className="a-label">Address</label>
                <input className="a-input" type="text" value={newVenueAddr}
                  onChange={e => setNewVenueAddr(e.target.value)} placeholder="Street address" />
              </div>
              <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
                <button type="button" className="a-btn a-btn--ghost" onClick={() => setShowVenueModal(false)}>Cancel</button>
                <button type="submit" className="a-btn a-btn--navy" disabled={addingVenue}>
                  {addingVenue ? 'Saving…' : 'Save'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ── Edit Booking Manager Modal ── */}
      {showEditBmModal && (
        <div className="a-modal-overlay" onClick={e => { if (e.target === e.currentTarget) setShowEditBmModal(false); }}>
          <div className="a-modal" style={{ maxWidth: '400px', width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <h2 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 600 }}>Edit Booking Manager</h2>
              <button onClick={() => setShowEditBmModal(false)} style={{ background: 'none', border: 'none', fontSize: '1.25rem', cursor: 'pointer', color: 'var(--muted)' }}>×</button>
            </div>
            {bmEditError && <div className="a-error" style={{ marginBottom: '0.75rem' }}>{bmEditError}</div>}
            <form onSubmit={handleSaveBmEdit}>
              <div className="a-field">
                <label className="a-label">Name</label>
                <input className="a-input" type="text" value={editBmForm.name}
                  onChange={e => setEditBmForm(f => ({ ...f, name: e.target.value }))} placeholder="Full name" />
              </div>
              <div className="a-field" style={{ marginBottom: 0 }}>
                <label className="a-label">Email *</label>
                <input className="a-input" type="email" value={editBmForm.email}
                  onChange={e => setEditBmForm(f => ({ ...f, email: e.target.value }))} required />
              </div>
              <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
                <button type="button" className="a-btn a-btn--ghost" onClick={() => setShowEditBmModal(false)}>Cancel</button>
                <button type="submit" className="a-btn a-btn--navy" disabled={savingBmEdit}>
                  {savingBmEdit ? 'Saving…' : 'Save'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ── Edit Sound Engineering Recipient Modal ── */}
      {showEditSoundieModal && (
        <div className="a-modal-overlay" onClick={e => { if (e.target === e.currentTarget) setShowEditSoundieModal(false); }}>
          <div className="a-modal" style={{ maxWidth: '400px', width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <h2 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 600 }}>Edit Sound Engineering Recipient</h2>
              <button onClick={() => setShowEditSoundieModal(false)} style={{ background: 'none', border: 'none', fontSize: '1.25rem', cursor: 'pointer', color: 'var(--muted)' }}>×</button>
            </div>
            {soundieEditError && <div className="a-error" style={{ marginBottom: '0.75rem' }}>{soundieEditError}</div>}
            <form onSubmit={handleSaveSoundieEdit}>
              <div className="a-field" style={{ marginBottom: 0 }}>
                <label className="a-label">Email Address *</label>
                <input className="a-input" type="email" value={editSoundieEmail}
                  onChange={e => setEditSoundieEmail(e.target.value)} required />
              </div>
              <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
                <button type="button" className="a-btn a-btn--ghost" onClick={() => setShowEditSoundieModal(false)}>Cancel</button>
                <button type="submit" className="a-btn a-btn--navy" disabled={savingSoundieEdit}>
                  {savingSoundieEdit ? 'Saving…' : 'Save'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ── Delete Venue Confirm Modal ── */}
      {showDeleteVenue && (
        <div className="a-modal-overlay" onClick={e => { if (e.target === e.currentTarget) setShowDeleteVenue(null); }}>
          <div className="a-modal">
            <h2 style={{ margin: '0 0 0.75rem', fontSize: '1.1rem', fontWeight: 600 }}>Remove Venue</h2>
            <p style={{ color: 'var(--text)', fontSize: '0.9rem', marginBottom: '1.25rem' }}>
              Remove <strong>{showDeleteVenue.name}</strong> from the venues list?
            </p>
            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
              <button className="a-btn a-btn--ghost" onClick={() => setShowDeleteVenue(null)}>Cancel</button>
              <button
                className="a-btn a-btn--danger"
                onClick={() => handleDeleteVenue(showDeleteVenue)}
                disabled={removingVenue === showDeleteVenue.id}
              >
                {removingVenue === showDeleteVenue.id ? 'Removing…' : 'Remove'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}